module.exports = __webpack_public_path__ + "static/media/mini-messages.e34bec80.svg";